mutation UserProfileUrgentUpdate($input: UserProfileUrgentUpdateInput!) {
  userProfileUrgentUpdate(input: $input) {
    clientMutationId
         _newUrgentLevel
  }
}
